import { GuaranteedSessionContext } from '@context/session/session-context';
import type { SessionModel } from '@generated-types';
import { useContext } from 'react';

export const useGuaranteedSession = (): SessionModel => {
    const { session } = useContext(GuaranteedSessionContext);

    if (session === null) {
        throw new Error('useGuaranteedSession must be used within a SessionProvider');
    }

    return session;
};
